/* ------------------------------ /
 * Main menu setup.
 * Priority nav based on https://github.com/lukejacksonn/GreedyNav
 * ------------------------------ */
// region Menu setup

const $mainNav = $('.main-nav');
const $mainNavWrap = $('.main-nav-menu');
const $mainNavLinks = $mainNav.find('> .menu-item');
const $mainNavToggleButton = $('.main-nav-menu-dropdown-toggle');
const $mainNavDropdown = $('.main-nav-menu-dropdown');
const $mainNavDropdownWrap = $('.main-nav-menu-dropdown-wrap');
const $win = theme.$win;


$mainNavToggleButton.click(function () {
    $mainNavDropdownWrap.toggleClass('open');
});

$mainNavDropdownWrap.find('.close').click(function () {
    $mainNavDropdownWrap.removeClass('open');
});

// region Duplicate menu items
let $menuDuplicates = $mainNavLinks.clone();

$menuDuplicates.each(function () {
    let $this = $(this);
    $this.attr('data-id', $this.attr('id'));
    $this.removeAttr('id');
});

$mainNavDropdown.append($menuDuplicates);

$menuDuplicates.filter('.menu-item-has-children').each(function () {
    let $thisItem = $(this);
    let $thisLink = $thisItem.find('> a');
    let $thisSub = $thisItem.find('> .sub-menu');
    let $thisItemParent = $thisItem.parent();

    // Clone the link into the sub menu if it has a valid url
    if ($thisLink.attr('href') !== undefined && $thisLink.attr('href') !== '' && $thisLink.attr('href') !== '#') {
        let $linkClone = $thisLink.clone();
        let linkwrapper = '<li class="' + $thisItem.attr('class') + ' sub-menu-parent-link-duplicate"></li>';
        $linkClone.prependTo($thisSub);
        $linkClone.wrap(linkwrapper);
        $linkClone.parent().removeClass('menu-item-has-children');
    }

    // Append back button to sub menu
    $thisSub.prepend('<li class="sub-menu-back menu-item">Back</li>');

    // Click events to open and close the sub menu
    $thisLink.click(function (e) {
        e.preventDefault();
        $mainNavDropdown.find('> .active').removeClass('active');
        $thisItem.addClass('active');
        $mainNavDropdownWrap.addClass('sub-open');
    });

    $thisSub.find('.sub-menu-back').click(function () {
        $mainNavDropdownWrap.removeClass('sub-open');
    });
});

// endregion

// region Menu item toggle logic
const measureOffset = 10;
let totalMenuWidth = 0;
let menuBreakpoints = [];
let isMenuSetup = false;

function setupMenuItemToggleVars() {
    console.log('Setup Toggle Vars');
    totalMenuWidth = 0;
    menuBreakpoints = [];

    $mainNavWrap.removeClass('is-setup');
    $mainNav.addClass('ready');
    $mainNavLinks.removeClass('hidden');
    $menuDuplicates.removeClass('visible');

    $mainNavLinks.outerWidth(function (i, v) {
        totalMenuWidth += v;
        menuBreakpoints.push(totalMenuWidth);
    });

    isMenuSetup = true;
    checkMenuItemToggle();
    $mainNavWrap.addClass('is-setup');
}

setupMenuItemToggleVars();

function checkMenuItemToggle() {
    if (!isMenuSetup) {
        setupMenuItemToggleVars();
        return;
    }
    let $visibleMenuLinks = $mainNavLinks.filter(':not(.hidden)');
    let $hiddenMenuLinks = $mainNavLinks.filter('.hidden');
    let menuAvailableSpace, menuNumOfVisibleItems, menuRequiredSpace;

    menuAvailableSpace = $mainNav.width() - measureOffset;
    menuNumOfVisibleItems = $visibleMenuLinks.length;
    menuRequiredSpace = menuBreakpoints[menuNumOfVisibleItems - 1];

    if (menuRequiredSpace > menuAvailableSpace) {
        $visibleMenuLinks.last().addClass('hidden');
        $menuDuplicates.eq($visibleMenuLinks.last().index()).addClass('visible');
        menuNumOfVisibleItems--;
        checkMenuItemToggle();

    } else if (menuAvailableSpace > menuBreakpoints[menuNumOfVisibleItems]) {
        $hiddenMenuLinks.first().removeClass('hidden');
        $menuDuplicates.eq($hiddenMenuLinks.first().index()).removeClass('visible');
        $mainNavDropdownWrap.removeClass('sub-open');
        menuNumOfVisibleItems++;
    }

    let isButtonOn = $mainNavToggleButton.hasClass('hidden');

    if (menuNumOfVisibleItems === $menuDuplicates.length) {
        $mainNavToggleButton.addClass('hidden');
        $mainNavDropdownWrap.removeClass('open');
    } else {
        $mainNavToggleButton.removeClass('hidden');
        if (isButtonOn) {
            checkMenuItemToggle();
        }
    }
}

$win.resize(function () {
    checkMenuItemToggle();
});

module.exports.setupVars = () => {
    setupMenuItemToggleVars();
};
